import React from "react"
import { Modal, ModalHeader, ROLE } from "baseui/modal"
import { Block } from "baseui/block"
import { ProgressBar } from "baseui/progress-bar"
import Loading from "~/components/Loading"
import { ExportProgress } from "~/utils/pdfExport"

interface ExportProgressModalProps {
  isOpen: boolean
  progress: ExportProgress | null
}

export default function ExportProgressModal({
  isOpen,
  progress,
}: ExportProgressModalProps) {
  const percentage = progress
    ? Math.round((progress.current / Math.max(progress.total, 1)) * 100)
    : 0

  return (
    <Modal
      onClose={() => {}}
      closeable={false}
      isOpen={isOpen}
      animate
      autoFocus
      size="auto"
      role={ROLE.dialog}
      overrides={{
        Dialog: {
          style: {
            borderTopRightRadius: "8px",
            borderEndStartRadius: "8px",
            borderEndEndRadius: "8px",
            borderStartEndRadius: "8px",
            borderStartStartRadius: "8px",
          },
        },
        Close: { style: { display: "none" } },
      }}
    >
      <ModalHeader>Exporting Your Photobook</ModalHeader>
      <Block $style={{ padding: "0 32px 32px 32px", minWidth: "400px" }}>
        <Block $style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
          <Loading color="#7158e2" width={60} height={60} />
        </Block>

        <Block $style={{ textAlign: "center", fontSize: "14px", color: "#666", marginBottom: "16px" }}>
          {progress?.stage || "Preparing…"}
        </Block>

        <ProgressBar
          value={percentage}
          overrides={{
            BarProgress: { style: { backgroundColor: "#7158e2" } },
            Bar: { style: { height: "8px", borderRadius: "4px" } },
            BarContainer: { style: { borderRadius: "4px" } },
          }}
        />

        <Block $style={{ textAlign: "center", fontSize: "14px", color: "#333", marginTop: "12px" }}>
          {percentage}%
        </Block>

        <Block $style={{ textAlign: "center", fontSize: "12px", color: "#999", marginTop: "16px" }}>
          Please do not close this window while exporting.
        </Block>
      </Block>
    </Modal>
  )
}
